import { render, staticRenderFns } from "./ReferralView.vue?vue&type=template&id=1db4d16e&scoped=true"
import script from "./ReferralView.vue?vue&type=script&lang=js"
export * from "./ReferralView.vue?vue&type=script&lang=js"
import style0 from "./ReferralView.vue?vue&type=style&index=0&id=1db4d16e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db4d16e",
  null
  
)

export default component.exports